import React from 'react'
import Bingo from '../../../assets/images/bingo/Bingo.png';

function Footer() {

    return (
        <div className="footerContainer ddd">
            <img src={Bingo} alt='BingoIcon' />
            {/* <div className='BingoFooterBorder'></div> */}
        </div>
    )
}

export default Footer
